import React from 'react'
import styled from 'styled-components'
import QuickLoanAnalysis from './QuickLoanAnalysis'
import UseOfProceeds from './UseOfProceeds'
import FadeInUpWrapper from '../common/FadeInUpWrapper'

const Container = styled(FadeInUpWrapper)`
  height: 87vh;
  display: flex;
  margin-top: 100px;
  align-items: center;
`
export default class TinkerTool extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: 'quickLoanAnalysis',
      loanAmount: props.loanAmount,
      hasError: false
    }
  }
  changeLoanAmount = loanAmount => {
    this.setState({ loanAmount })
  }
  changeModal = modal => {
    this.setState({ modal })
  }
  renderModal = () => {
    const { entity, toggleModal, years, product, allCashflowData, useOfFund, loan, entities, refetch } = this.props
    const { modal, loanAmount } = this.state

    if (modal === 'quickLoanAnalysis') {
      return (
        <QuickLoanAnalysis
          entity={entity}
          toggleModal={toggleModal}
          years={years}
          product={product}
          loanAmount={loanAmount}
          allCashflowData={allCashflowData}
          changeLoanAmount={this.changeLoanAmount}
          changeModal={() => this.changeModal('useOfProceeds')}
          loan={loan}
          entities={entities}
          refetch={refetch}
        />
      )
    } else if (modal === 'useOfProceeds') {
      return (
        <UseOfProceeds
          refetch={refetch}
          loanAmount={loanAmount}
          toggleModal={toggleModal}
          onBackClick={() => this.changeModal('quickLoanAnalysis')}
          useOfFund={useOfFund}
          loanId={loan.rid}
          cre={loan.product.category === 'cre'}
          reload
        />
      )
    }
  }
  render() {
    return (
      <Container>
        {this.renderModal()}
      </Container>
    )
  }
}
